<template>
	<div class="home">
		<div 
		      v-for="(image, index) in images" 
		      :key="index" 
		      class="cardp"
		      :style="{ fontFamily: image.fontFamily }"
		    >
		      <img class="tupian" v-lazy="image.src" />
		    </div>
		
		<!-- 添加防伪码验证区域 -->
		<div class="verification-section">
			<div class="verification-title">产品真伪查询</div>
			<div class="verification-subtitle">扫描或输入产品防伪码，验证您的产品</div>
			<scan-qr></scan-qr>
		</div>
		
		<div style="display: flex;justify-content: space-around;width: 100%;padding: 4vw 0;box-sizing: border-box;">
			<img class="mg" width="31%" src="../assets/a1.png"/>
			<img class="mg" width="31%" src="../assets/a2.png"/>
			<img class="mg" width="31%" src="../assets/a3.png"/>
		</div>
		<div style="display: flex;flex-direction: column;width: 100%;box-sizing: border-box;padding: 3vw;font-family: ago4;align-items: center;font-size: 1.4vw;font-weight: bold;">
			<div style="display: flex;flex-direction: column;width:100%;font-family: ago3;font-size: 5vw;align-items: center;padding: 2vw 0;">
				<div>Your beautiful skin</div>
				<div>starts here</div>
			</div>
		</div>
	</div>
</template>

<script>
	import '@/assets/text.css';
	import ScanQR from '@/components/ScanQR.vue';
	
	export default {
		components: {
			ScanQR
		},
		data(){
			return{
				images: [
				        { src: require('@/assets/f1.jpg'), fontFamily: "'ago2', sans-serif" },
				        { src: require('@/assets/f2.png'), fontFamily: 'ago3' },
				        { src: require('@/assets/f3.jpg') },
				        { src: require('@/assets/f4.png') },
				        { src: require('@/assets/f5.jpg') },
				        { src: require('@/assets/f6.png') },
				        { src: require('@/assets/f7.png') },
				        { src: require('@/assets/f8.png') },
				        { src: require('@/assets/f9.jpg') },
				        { src: require('@/assets/f10.png') }
				      ],
			}
		},
		methods: {
		  },
	}
</script>

<style scoped>
.home {
    width: 100vw;
    display: flex;
    flex-direction: column;
    -ms-overflow-style: none;  /* 适用于 Internet Explorer 和 Edge */
    scrollbar-width: none;  /* 适用于 Firefox */
	box-sizing: border-box;
	position: relative;
	overflow: auto;
}




	.cardp {
		width: 100%;
		position: relative;
		box-sizing: border-box;
	}

	.tupian {
		width: 100%;
		display: block;
		/* height: 100vh; */

	}

	.Title {
		position: absolute;
	}
	.cardme{
		
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 3vw 5vw;
		box-sizing: border-box;
	}
	.size1{
		font-size: 1.3vw;
	}
	/* From Uiverse.io by gharsh11032000 */ 
	.card {
	  position: relative;
	  width: 25vw;
	  /* height: 230px; */
	  border-radius: 30px;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  overflow: hidden;
	  perspective: 1000px;
	  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
	  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
	}
	.card img{
		width: 100%;
		height: 100%;
	}

	
	.card:hover {
	  transform: scale(1.05);
	  box-shadow: 0 8px 16px rgba(255, 255, 255, 0.2);
	}
	
	.card__content {
	  position: absolute;
	  top: 0;
	  left: 0;
	  width: 100%;
	  height: 100%;
	  padding: 20px;
	  box-sizing: border-box;
	  background-color: rgba(255, 255, 255, 0.8);
	  transform: rotateX(-90deg);
	  transform-origin: bottom;
	  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
	}
	
	.card:hover .card__content {
	  transform: rotateX(0deg);
	}
	
	.card__title {
	  margin: 0;
	  font-size: 3vw;
	  color: #333;
	  font-weight: 700;
	}
	
	
	
	.card__description {
	  margin: 10px 0 0;
	  font-size: 1vw;
	  color: #777;
	  line-height: 1.4;
	}
	.mg {
	  transition: transform 0.5s ease; /* 过渡效果，0.3秒平滑放大 */
	  border-radius: 10px;
	  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
	}
	
	.mg:hover {
	  transform: scale(1.05); /* 鼠标悬停时放大10% */
	}
.back-to-top {
  position: fixed; /* 相对于 .home 容器定位 */
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 50%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  display: none; /* 默认隐藏 */
  justify-content: center;
  align-items: center;
  font-size: 20px;
  transition: opacity 0.3s, transform 0.3s;
  z-index: 1000;
}

.back-to-top:hover {
  background-color: #0056b3;
  transform: scale(1.1);
}

.verification-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 3vw 0;
  background-color: #f9f9f9;
  border-top: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}

.verification-title {
  font-size: 2.5vw;
  font-family: 'ago2', sans-serif;
  margin-bottom: 1vw;
  color: #4f29f0;
}

.verification-subtitle {
  font-size: 1.2vw;
  font-family: 'ago4', sans-serif;
  margin-bottom: 2vw;
  color: #666;
}

</style>